// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navigation_navigation__emvaz","backwards":"navigation_backwards__N38XD","forwards":"navigation_forwards__AvSNo","sticky":"navigation_sticky__arelx"};